export default __webpack_public_path__ + "static/media/Dagger of the Faceless Sphinx.636e31bf.jpg";